"use client"
import { MemoizedReactMarkdown } from "@/components/Markdown"
import { createAssetUrl } from "@/lib/s3"
import { cn } from "@/lib/tailwind"

export function TbMarkdown({ text, className }: { text: string; className?: string }) {
  return (
    <MemoizedReactMarkdown
      className={cn("prose dark:prose-invert break-words prose-pre:p-0 prose-p:leading-relaxed", className)}
      components={{
        p: ({ node: _, ...props }) => <p {...props} className="mb-2 last:mb-0" />,
        a: ({ node: _, ...props }) => <a {...props} href={props.href || "/"} target="_blank" rel="noreferrer noopener" />,
        img: ({ node: _, ...props }) => (
          <img
            {...props}
            height={600}
            width={800}
            alt="content"
            src={createAssetUrl(props.src) || ""}
            className="m-0 max-h-[300px] w-full rounded-lg bg-gray-50 object-cover dark:bg-gray-950"
          />
        ),
      }}
    >
      {text?.replace(/\【.*?】/g, "")}
    </MemoizedReactMarkdown>
  )
}
